import { MutableRefObject, useState } from 'react';
import styled from 'styled-components';
import { getSampleCompilationContext } from '../../context/sample-compilation-context';
import { useTranslation } from 'react-i18next';

const StyledSuggestionModal = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-height: 15%;
  max-width: fit-content;
`;

const StyledSuggestionList = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

interface TemplateEditorCompilationSuggestionsModalProps {
  show: boolean;
  handleClick: (path: string) => void;
  caretPosition: MutableRefObject<{ left: number; top: number }>;
}

export const TemplateEditorCompilationSuggestionsModal: React.FC<TemplateEditorCompilationSuggestionsModalProps> = ({
  show,
  handleClick,
  caretPosition,
}) => {
  const { t } = useTranslation('campaigns');

  const sampleContext = getSampleCompilationContext();
  const paths = pathsExtractor(sampleContext);
  const [filteredPaths, setFilteredPaths] = useState(paths);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPaths = paths.filter(path => path.toLowerCase().includes(event.target.value));
    setFilteredPaths(newPaths);
  };

  function pathsExtractor(context: object) {
    let fullPaths: string[] = [];
    for (const key in context) {
      if (typeof context[key] === 'object') {
        fullPaths = [...fullPaths, ...pathsExtractor(context[key])];
      } else if (context[key]) fullPaths.push(context[key]);
    }
    return fullPaths;
  }

  return (
    <>
      {show && (
        <StyledSuggestionModal
          style={{
            left: `${caretPosition.current.left}px`,
            top: `${caretPosition.current.top}px`,
          }}
        >
          <input
            placeholder={t('campaigns:offsiteEditor.suggestionsModal.placeholder')}
            type="text"
            onChange={handleChange}
            data-testid="test-input"
          />
          <StyledSuggestionList>
            {filteredPaths.map(
              (path, i) =>
                typeof path !== 'object' && (
                  <button
                    onClick={() => {
                      handleClick(path);
                      setFilteredPaths(paths);
                    }}
                    key={i}
                    data-testid="suggested-path"
                  >
                    {path}
                  </button>
                ),
            )}
          </StyledSuggestionList>
        </StyledSuggestionModal>
      )}
    </>
  );
};
